export var AvailableStaffStatus;
(function (AvailableStaffStatus) {
    AvailableStaffStatus[AvailableStaffStatus["Initial"] = 0] = "Initial";
    AvailableStaffStatus[AvailableStaffStatus["Fetching"] = 1] = "Fetching";
    AvailableStaffStatus[AvailableStaffStatus["FetchSuccess"] = 2] = "FetchSuccess";
    AvailableStaffStatus[AvailableStaffStatus["FetchingUnavailable"] = 3] = "FetchingUnavailable";
    AvailableStaffStatus[AvailableStaffStatus["FetchUnavailableSuccess"] = 4] = "FetchUnavailableSuccess";
    AvailableStaffStatus[AvailableStaffStatus["Error"] = 5] = "Error";
})(AvailableStaffStatus || (AvailableStaffStatus = {}));
